function getVariantJson(variantId) {
    const $variantJSON = document.getElementById(`VariantJSON-${variantId}`);
    return $variantJSON ? JSON.parse($variantJSON.textContent) : null;
}

function getAddedVariantJSON(productId) {
    const $addedVariantJSON = document.getElementById(`AddedVariantJSON-${productId}`);
    return $addedVariantJSON ? JSON.parse($addedVariantJSON.textContent) : null;
}

function updateAddedVariantJSON(variantId, productId, quantity) {
    const $addedVariantJSON = document.getElementById(`AddedVariantJSON-${productId}`);
    const json = $addedVariantJSON ? JSON.parse($addedVariantJSON.textContent) : null;
    if(json) {
        if(quantity === 0) {
            json.variantIds = json.variantIds.filter(function(id) {
                return id !== parseInt(variantId);
            });
        } else {
            json.variantIds.push(parseInt(variantId));
        }
        $addedVariantJSON.textContent = JSON.stringify(json);
    }
}

async function checkAddable(productId, isReserved) {

    // shopify ajax api からカートデータを取得
    const cart = await fetch('/cart.js').then(response => response.json());
    const cartItems = cart.items;

    // カートが空ならtrue
    if (!cartItems.length) {
        return true;
    }

    // カートから予約商品のみ抽出
    const reservationItems = cartItems.filter(function (cartItem) {
        let result = false
        if("properties" in cartItem && "発注区分" in cartItem.properties) {
            result = cartItem.properties["発注区分"] === "FOなど受注品";

            if(!result && "reserved" in cartItem.properties) {
                result = cartItem.properties.reserved === "reserved";
            }
        }
        return result;
    });

    // 通常商品を予約商品の含まないカートに追加する場合はtrue
    if (!isReserved && !reservationItems.length) {
        return true;
    }

    // 同一商品がカートに追加済の場合はtrue
    const includeSameProductInCart = reservationItems.some(function (reservationItem) {
        return productId === reservationItem.product_id;
    });
    if (includeSameProductInCart) {
        return true
    }

    //同時購入可能な予約商品コレクションのデータ
    const reservationCollectionProductIdsList = [
        reservationCollectionProductIds1,
        reservationCollectionProductIds2,
        reservationCollectionProductIds3
    ];

    const allProductIds = [productId];
    cartItems.forEach(function (cartItem) {
        allProductIds.push(cartItem.product_id);
    });

    let result = false;
    reservationCollectionProductIdsList.forEach(function (list) {
        let targetCollectionProductIds = []; //予約と同時購入可能な商品のコレクション
        if (typeof list !== 'undefined') {
            targetCollectionProductIds = list;
        }

        // 追加する商品とカート内商品が全て予約コレクションに含まれる場合はtrue
        const targetResult = allProductIds.every(function (id) {
            return targetCollectionProductIds.includes(id);
        });

        if (targetResult) {
            result = true;
        }
    });
    return result;
}